// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/distinte/ordini-generabili?societaId&commessaId',
    requestBody: null,
    response: '{"success":true,"data":[{"ordineId":"number","numero":"string","stato":"string","dataConferma":"string","clienteRagioneSociale":"string","commessa":{"id":"number","numero":"string","descrizione":"string"},"distinteEsistenti":"number","righeMerceResidue":"number","qtaMerceResidua":"number","righeLavorazioniResidue":"number","qtaLavorazioniResidua":"number"}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/distinte/genera-massive',
    requestBody: '{"elementi":[{"ordineId":"number","tipi":["MERCE|LAVORAZIONI"]}],"conferma":"boolean"}',
    response: '{"success":true,"data":{"risultati":[{"ordineId":"number","ordineNumero":"string","tipo":"MERCE|LAVORAZIONI","esito":"CREATA|SALTATA|ERRORE","distintaId":"number","numero":"number","etichetta":"string","nRighe":"number","stato":"string","motivo":"string"}],"create":"number"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
